import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function Protected({ children }: { children: JSX.Element }) {
  const { loading, user } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'hsl(var(--bg-app))' }}>
        <div className="text-ivory/60">Loading...</div>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/signin" replace />;
  
  return children;
}
